<template>
  <div>
    <div>
      <span>
        事件：
        <span v-if="type == 2">
          新增子账号
        </span>
        <span v-if="type == 3">
          修改子账号
        </span>
        <span v-if="type == 11">
          修改权限
        </span>
      </span>
    </div>
    <template v-if="type == 2 || type == 3">
      <div
        style="display:flex;justify-content:space-around;align-items:center;margin:40px"
      >
        <el-card v-if="type === 3" class="box-card">
          <div class="detail-left">
            <el-form
              label-position="right"
              label-width="80px"
              :model="oldJSON"
              disabled
            >
              <el-form-item label="子账号名">
                <el-input v-model="oldJSON.userName"></el-input>
              </el-form-item>
              <el-form-item label="角色">
                <el-input v-model="oldJSON.roleName"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input value="******"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="oldJSON.fullName"></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
                <el-input v-model="oldJSON.phone"></el-input>
              </el-form-item>
              <el-form-item label="部门">
                <el-input v-model="oldJSON.department"></el-input>
              </el-form-item>
              <el-form-item label="职位">
                <el-input v-model="oldJSON.position"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <div v-if="type === 3" class="arrow">
          <i style="font-size:40px" class="el-icon-right"></i>
        </div>
        <el-card class="box-card">
          <div class="detail-right">
            <el-form
              label-position="right"
              label-width="80px"
              :model="newJSON"
              disabled
            >
              <el-form-item label="子账号名">
                <el-input v-model="newJSON.userName"></el-input>
              </el-form-item>
              <el-form-item label="角色">
                <el-input v-model="newJSON.roleName"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input value="******"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="newJSON.fullName"></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
                <el-input v-model="newJSON.phone"></el-input>
              </el-form-item>
              <el-form-item label="部门">
                <el-input v-model="newJSON.department"></el-input>
              </el-form-item>
              <el-form-item label="职位">
                <el-input v-model="newJSON.position"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
    </template>
    <template v-if="type == 11">
      <div
        style="display:flex;justify-content:space-around;align-items:center;margin:40px"
      >
        <el-card class="box-card">
          <div class="detail-left">
            <div>
              <div>项目权限</div>
              <div style="max-height:240px;overflow-y:auto">
                <el-tree
                  :check-strictly="false"
                  node-key="projectId"
                  ref="projectTree"
                  :default-expand-all="true"
                  :data="oldJSON.limitsOfAuthorityOne"
                  :props="propsProject"
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span>{{ node.label }}</span>
                    <!-- <span>{{ data.userName }}</span> -->
                  </span>
                </el-tree>
              </div>
            </div>
            <div>
              <div>下列权限可重复分配给不同子账号使用</div>
              <div style="max-height:240px;overflow-y:auto">
                <el-tree
                  ref="othersTreeOld"
                  node-key="menuId"
                  :default-expand-all="true"
                  :data="oldJSON.limitsOfAuthorityTwo"
                  :props="props"
                  show-checkbox
                ></el-tree>
              </div>
            </div>
          </div>
        </el-card>
        <div class="arrow">
          <i style="font-size:40px" class="el-icon-right"></i>
        </div>
        <el-card class="box-card">
          <div class="detail-right">
            <div>
              <div>项目权限</div>
              <div style="max-height:240px;overflow-y:auto">
                <el-tree
                  :check-strictly="false"
                  node-key="projectId"
                  ref="projectTree"
                  :default-expand-all="true"
                  :data="newJSON.limitsOfAuthorityOne"
                  :props="propsProject"
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span>{{ node.label }}</span>
                    <!-- <span>{{ data.userName }}</span> -->
                  </span>
                </el-tree>
              </div>
            </div>
            <div>
              <div>下列权限可重复分配给不同子账号使用</div>
              <div style="max-height:240px;overflow-y:auto">
                <el-tree
                  ref="othersTreeNew"
                  node-key="menuId"
                  :default-expand-all="true"
                  :data="newJSON.limitsOfAuthorityTwo"
                  :props="props"
                  show-checkbox
                ></el-tree>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </template>
  </div>
</template>

<script>
import { accountManagement } from '@/api/ajax';
export default {
  props: {
    id: {
      type: [String, Number],
      require: true
    },
    type: {
      type: [String, Number],
      require: true
    }
  },
  name: 'MainAccountLog',
  data() {
    return {
      propsProject: {
        label: 'projectName',
        children: 'children'
      },
      props: {
        children: 'list',
        label: 'menuName',
        disabled: () => true
      },
      oldJSON: {},
      newJSON: {},
      othersTreeSelectedOld: new Set(),
      othersTreeSelectedNew: new Set()
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.getMainAccountLogDetail();
  },
  methods: {
    getMainAccountLogDetail() {
      accountManagement.getLogDetail({ id: this.id }).then(res => {
        this.oldJSON = JSON.parse(res.pdata.primaryJson);
        this.newJSON = JSON.parse(res.pdata.updateJson);
        this.oldJSON.limitsOfAuthorityTwo.map(item => {
          item.list.map(k => {
            if (k.flag === 1) {
              this.othersTreeSelectedOld.add(k.menuId);
            }
          });
        });
        this.newJSON.limitsOfAuthorityTwo.map(item => {
          item.list.map(k => {
            if (k.flag === 1) {
              this.othersTreeSelectedNew.add(k.menuId);
            }
          });
        });
        this.$refs.othersTreeOld.setCheckedKeys(this.othersTreeSelectedOld);
        this.$refs.othersTreeNew.setCheckedKeys(this.othersTreeSelectedNew);
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
